
define('text!templates/modals/claim/doc-collection-item.ejs',[],function () { return '<td class="claim-doc-num">Счет входящий <%= docNum %> от <%= date(docDate) %></td>\n<td class="claim-doc-value">Сумма: <%= money(value) %> <small><%= currency %></small></td>';});

